import { useToastStore } from '@/stores/toast-store';

export function useToast() {
	const toastStore = useToastStore();
	
	// success, danger, info, warning
	function displayToast(message, variant = 'primary', duration = 5000 ) {
		const id = Date.now();
		let heading = null;
		if (typeof message !== 'string') {
			heading = message.heading;
			message = message.message;
		}
		
		toastStore.addToast({ id, message, heading, variant });
		
		if(duration > 0){
			setTimeout(() => {
				toastStore.removeToast(id);
			}, duration);
		}
		
	}
	
	return { displayToast };
}